export const CircuitoResoData = [
  {
    pregunta: "¿La orden médica indica con contraste o Gadolinio?",
    name: "contraste",
    valor: null,
    visible: true,
    key: 0
  },
  {
    pregunta: `¿Tiene insuficiencia renal?`,
    name: "renal",
    valor: null,
    visible: false,
    key: 1
  },
  {
    pregunta: `¿Tiene un peso superior a 100kg?`,
    name: "pesoSuperior",
    valor: null,
    visible: true,
    key: 2
  },
  {
    pregunta: `¿Tiene Marcapasos o Implantes Metálicos en el cuerpo?`,
    name: "marcaPasos",
    valor: null,
    visible: true,
    key: 3
  }
];
